import React, { useEffect, useState } from 'react'
import FacilityRatingsTabular from '../../Children/Tabular/FacilityRatingsTabular';
import FacilityRatingsGraphical from '../../Children/Graphical/FacilityRatingsGraphical';
import CustomButton from '../../../../../../../Common/CustomButton/CustomButton';
import { showAlert } from '../../../../../../../../Assests/Utility';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { sagaActions } from '../../../../../../../../../sagas/sagaActions';
import { AppConstant } from '../../../../../../../../Assests/AppConstant';
import { calculateMonthDifference } from '../../../../../../../../../Utils/DateUtils';
import DownloadSectionBE from '../../../../../DownloadSection/DownloadSectionBE';
import { getUserSelector } from '../../../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { useSelector } from 'react-redux';
import moment from 'moment';

const FacilityRatingsWrapper = (props) => {
  const dispatch = useDispatch()
  const [view, setView] = useState('T');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const userObj = useSelector(getUserSelector);
  const { selectedWarehouse, cu_id, userType, userAccountDetails } = userObj;
  const [currentFilterSelected, setCurrentFilterSelected] = useState({ name: 'All' });
  const [startTimeState, setStartTimeState] = useState(null);
  const [endTimeState, setEndTimeState] = useState(null);

  const [isError, setIsError] = useState(false)

  const downloadData = (type) => {
    const eDate = moment(endDate).hours(23).minutes(59).seconds(59)
    let payload = {
      fileType: type,
      fileName: "Facility-Ratings-" + userAccountDetails?.UserName,
      rating: currentFilterSelected?.name === 'All' ? null : currentFilterSelected?.name,
      // startDate: moment(startDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
      // endDate: moment(eDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
      "startDate": combineDateAndTime(startDate, startTimeState, true),
      "endDate": combineDateAndTime(endDate, endTimeState, true),
      warehouse_id: selectedWarehouse.ID,
    }
    dispatch({ type: sagaActions.FACILITY_RATIING_DOWNLOAD, payload });
  }

  const combineDateAndTime = (date, time, addTimeZone) => {
    if (!date || !time) return null;

    // Extract date and time parts separately
    const datePart = moment(date).format('YYYY-MM-DD');

    // Convert to UTC and format
    if (addTimeZone) {
      return `${datePart}T${time}:00Z`;
    }
    return `${moment(date).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)} ${time}`;
  };
  const setCurrentFilterDetails = (data) => {
    setCurrentFilterSelected(data);

  }

  return (
    <>
      <div className='m-2 d-flex justify-content-between'>
        <div>
          <CustomButton
            disabled={view === 'T' ? true : false}
            isLoading={false}
            title={'Tabular'}
            className={`addButton mx-1 ${view === 'T' ? '' : 'disabledActionColor'}`}
            onClick={() => {
              dispatch({ type: sagaActions.RESET_FACILITY_RATINGS_ACTION });
              setView('T')
            }}>Tabular</CustomButton>
          <CustomButton
            disabled={view === 'G' ? true : false}
            isLoading={false}
            title={'Graphical'}
            className={`addButton mx-1 ${view === 'G' ? '' : 'disabledActionColor'}`}
            onClick={() => {
              dispatch({ type: sagaActions.RESET_FACILITY_RATINGS_ACTION });
              setView('G')
            }}
          >Graphical</CustomButton>
        </div>
        <DownloadSectionBE downloadData={downloadData} isDisabled={isError} ></DownloadSectionBE>
      </div>
      {view === 'T' ? <FacilityRatingsTabular {...props} view={view} isError={isError} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} setCurrentFilterDetails={setCurrentFilterDetails} startTimeState={startTimeState} setStartTimeState={setStartTimeState} endTimeState={endTimeState} setEndTimeState={setEndTimeState} /> : <FacilityRatingsGraphical {...props} view={view} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} isError={isError} startTimeState={startTimeState} setStartTimeState={setStartTimeState} endTimeState={endTimeState} setEndTimeState={setEndTimeState} />}
    </>
  );
}

export default FacilityRatingsWrapper;